<app-grid
[gridBulkSection]=gridBulkSection
[gridColumnsParam]=gridColumnsParam
[gridFilter]=gridFilter
[gridPanelPreferences]=gridPanelPreferences
[gridSearch]=gridSearch
[gridName]="gridName"
[exportCSV]="true"
[sectionMessage]=gridSectionMessage
(onGetGridData)="getPaymentOperations()">
  <mat-list class="custom-mat-list list-grid-std list-billing-operations">
    <mat-list-item *ngIf="_skeleton.skeletonGridDataLoader" class="custom-mat-list-item grid-row grid-row-header">
      <div class="cell-wrapper col-first">
        <div class="cell flex-order order-0">
          <label matLine class="label-header">Target Date</label>
        </div>
      </div>
      <div class="cell-wrapper col-info">
        <div class="cell flex-order order-1">
          <label matLine class="label-header">Executed On</label>
        </div>
        <div class="cell flex-order order-2">
          <label matLine class="label-header">Completed On</label>
        </div>
        <div class="cell flex-order order-3">
          <div class="cell-inner">
            <label matLine class="label-header">Invoices</label>
            <label matLine class="label-header">Processed</label>
          </div>
        </div>
        <div class="cell flex-order order-4">
          <div class="cell-inner">
            <label matLine class="label-header">Error</label>
            <label matLine class="label-header">Amount</label>
          </div>
        </div>
        <div class="cell flex-order order-5">
          <div class="cell-inner">
            <label matLine class="label-header">Declined</label>
            <label matLine class="label-header">Amount</label>
          </div>
        </div>
        <div class="cell flex-order order-6">
          <div class="cell-inner">
            <label matLine class="label-header">Paid</label>
            <label matLine class="label-header">Amount</label>
          </div>
        </div>
      </div>
      <div class="cell-wrapper col-actions">
        <div class="cell"></div>
      </div>
    </mat-list-item>
    <div *ngIf="_skeleton.skeletonGridDataLoader">
      <mat-list-item *ngFor="let item of collectionOfPaymentRun; let i = index;" class="custom-mat-list-item grid-row">
        <div class="cell-wrapper col-first">
          <div class="cell flex-order order-0">
            <label class="status">
              <div [class]="'status-inner'" [ngClass]="{
                'status-completed': item.status === _paymentRunStatus.completed,
                'status-error': item.status === _paymentRunStatus.completedWithErrors || item.status === _paymentRunStatus.error,
                'status-pending': item.status === _paymentRunStatus.pending,
                'status-processing': item.status === _paymentRunStatus.processing,
                'status-dunning': item.status === _paymentRunStatus.dunning,
                'status-declined': item.status === _paymentRunStatus.declined }">

                <span matLine *ngIf="item.status === _paymentRunStatus.completed" class="status-label">Completed</span>
                <span matLine *ngIf="item.status === _paymentRunStatus.completedWithErrors" class="status-label">Done with Error</span>
                <span matLine *ngIf="item.status === _paymentRunStatus.dunning" class="status-label">Dunning</span>
                <span matLine *ngIf="item.status === _paymentRunStatus.error" class="status-label">Error</span>
                <span matLine *ngIf="item.status === _paymentRunStatus.pending" class="status-label">Pending</span>
                <span matLine *ngIf="item.status === _paymentRunStatus.processing" class="status-label">Processing</span>
                <span matLine *ngIf="item.status === _paymentRunStatus.declined" class="status-label">Declined</span>
              </div>
            </label>
            <div class="cell-inner cell-inner-with-status">
              <label matLine class="label-primary">{{item.targetDate | dateTz  }}</label>
              <label matLine class="label-secondary">{{item.targetDate | dateTz: 'longTime' }}</label>
            </div>
          </div>
        </div>
        <div class="cell-wrapper col-info">
          <div class="cell flex-order order-1">
            <div class="cell-inner">
              <label matLine class="label-primary">{{item.executedOn | dateTz }}</label>
              <label matLine class="label-secondary">{{item.executedOn | dateTz: 'longTime' }}</label>
            </div>
          </div>
          <div class="cell flex-order order-2">
            <div class="cell-inner">
              <label matLine class="label-primary">{{item.completedOn | dateTz }}</label>
              <label matLine class="label-secondary">{{item.completedOn | dateTz: 'longTime' }}</label>
            </div>
          </div>
          <div class="cell flex-order order-3">
            <label *ngIf="item.invoiceCount" matLine class="label-primary">{{item.invoiceCount}}</label>
            <label *ngIf="!item.invoiceCount" matLine class="label-primary">-</label>
          </div>
          <div class="cell flex-order order-4">
            <label *ngIf="item.errorAmount" matLine class="label-primary">{{companyCurrencyBase?.currency.symbol}}{{item.errorAmount}} {{companyCurrencyBase?.currency.iso3}}</label>
            <label *ngIf="!item.errorAmount" matLine class="label-primary">-</label>
          </div>
          <div class="cell flex-order order-5">
            <label *ngIf="item.declinedAmount" matLine class="label-primary">{{companyCurrencyBase?.currency.symbol}}{{item.declinedAmount}} {{companyCurrencyBase?.currency.iso3}}</label>
            <label *ngIf="!item.declinedAmount" matLine class="label-primary">-</label>
          </div>
          <div class="cell flex-order order-6">
            <label *ngIf="item.paidAmount" matLine class="label-primary">
              <b>
              {{companyCurrencyBase?.currency.symbol}}{{item.paidAmount}} {{companyCurrencyBase?.currency.iso3}}
            </b>
            </label>
            <label *ngIf="!item.paidAmount" matLine class="label-primary">-</label>
          </div>
        </div>
        <div class="cell-wrapper col-actions">
          <button mat-icon-button [matMenuTriggerFor]="billingActions" class="custom-mat-icon-button button-actions">
            <mat-icon svgIcon="ico-actions" class="custom-mat-icon ico-size ico-xs"></mat-icon>
          </button>
          <mat-menu #billingActions="matMenu" class="custom-mat-menu-panel">
            <a mat-menu-item [routerLink]="['/main/settings/advanced/payment-operations/', item.id, 'list']" class="custom-mat-menu-item">
              <mat-icon svgIcon="ico-schedule" class="custom-mat-icon ico-size ico-1xs"></mat-icon>View Report
            </a>
            <a *ngIf="!(item.status === _paymentRunStatus.completed || item.status === _paymentRunStatus.processing || item.status === _paymentRunStatus.pending)" mat-menu-item (click)="manuallyRerunPaymentRun(item.id)" class="custom-mat-menu-item">
              <mat-icon svgIcon="ico-schedule" class="custom-mat-icon ico-size ico-1xs"></mat-icon>Manually Re-run
            </a>
          </mat-menu>
        </div>
      </mat-list-item>
    </div>
    <skeleton-loader-grid-header [gridBulkSection]=false></skeleton-loader-grid-header>
    <skeleton-loader-grid-body [gridBulkSection]=false [numberOfRows]=1></skeleton-loader-grid-body>
  </mat-list>
</app-grid>
